import { HM_EWH_VIEW } from '@/fixtures'

export default {
  path: 'summary-hm-ewh',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Summary HM & EWH',
      component: () => import('@/views/menus/SummaryHM/Index'),
      meta: {
        permission: HM_EWH_VIEW
      }
    },
    {
      path: 'detail',
      name: 'Report Summary HM & EWH',
      component: () => import('@/views/menus/SummaryHM/View'),
      meta: {
        permission: HM_EWH_VIEW
      }
    }
  ]
}
